import React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import SignUpComponent from '../components/SignUpComponent';

class SignUpPage extends React.Component {
	render() {
		return (
			<Box sx={{
				display: 'flex',
				flexDirection: 'column'
			}}>
				<Container component="main" maxWidth="sm">
					<SignUpComponent />
				</Container>
			</Box>
		);
	}
}

export default SignUpPage;